module.exports = __webpack_public_path__ + "img/1b477e3.png";